.dtable{
    min-width: 400;
}